import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http'
import {Injectable} from '@angular/core'

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  credentials: {token: string, token_type: string}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const token = this.token

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: token
        }
      })
    }

    return next.handle(request)
  }

  setCredentials(credentials: {token: string, token_type: string}) {
    this.credentials = credentials
  }

  removeCredentials() {
    this.credentials = null
  }

  private get token() {
    if (this.credentials) {
      if (this.credentials.token) {
        return 'Bearer ' + this.credentials.token
      }
    }

    return null
  }
}
